import { FC, useState } from 'react';
import { createRoot } from 'react-dom/client';
import Modal from '@components/Modal/Modal';
import Video from '@components/Video/Video';
import createModalMount from '@functions/createReactModalMount';
import closeModal from '@functions/closeReactModal';
import ModalMount from '@type/ModalMount';

type Props = {
    videoId: string;
} & ModalMount;

const ElementorWistiaVideoModal: FC<Props> = ({ mount, root, videoId }) => {
    const [open, setOpen] = useState(true);

    return (
        <Modal
            isOpen={open}
            testId={'modal--elementor-wistia-video'}
            onClose={() => {
                closeModal({
                    domElement: mount,
                    appRoot: root,
                    closeAction: setOpen,
                });
            }}
            appElement={mount}
        >
            <Video embedCode={videoId} />
        </Modal>
    );
};

const wistiaVideoButtons = Array.from(document.querySelectorAll('.tb-elementor-wistia-video-modal button'));

wistiaVideoButtons.forEach((buttons) => {
    buttons.addEventListener('click', function () {
        const modalInstanceName = this.dataset.elementorWistiaVideoModalInstance.replace(/\s+/g, '-').toLowerCase();
        const videoId = this.dataset.elementorWistiaVideoId;
        const wistiaVideoModal = createModalMount(`${modalInstanceName}-modal`);
        const wistiaVideoModalRoot = createRoot(wistiaVideoModal);
        wistiaVideoModalRoot.render(
            <ElementorWistiaVideoModal mount={wistiaVideoModal} root={wistiaVideoModalRoot} videoId={videoId} />
        );
    });
});
